import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { JAPANESE_ID, CHINESE_ID } from 'constants.js';
import { LOCALE } from 'utils/environment';

import enStrings from '../i18n/en-us.json';
import jaStrings from '../i18n/ja-jp.json';
import zhStrings from '../i18n/zh-cn.json';

export default class Translate extends Component {
  constructor() {
    super();
    switch (LOCALE) {
      case JAPANESE_ID:
        this.language = jaStrings;
        break;

      case CHINESE_ID:
        this.language = zhStrings;
        break;

      default:
        this.language = enStrings;
    }
  }
  sanitizeTokens(string) {
    const { params } = this.props;
    if (params) {
      for (var key in params) {
        string = string.replace('${' + key + '}', params[key]);
      }
    }
    return string;
  }

  render() {
    const { stringID, defaultValue } = this.props;
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: this.language[stringID]
            ? this.sanitizeTokens(this.language[stringID])
            : defaultValue,
        }}
      />
    );
  }
}

export function getString(stringID) {
  switch (LOCALE) {
    case JAPANESE_ID:
      return jaStrings[stringID];

    case CHINESE_ID:
      return zhStrings[stringID];

    default:
      return enStrings[stringID];
  }
}

Translate.propTypes = {
  stringID: PropTypes.string.isRequired,
  defaultValue: PropTypes.string.isRequired,
  params: PropTypes.object,
};
